<template>
	<modal containerClass="workshop-service-report" v-model="modal">
		<text-button slot="label"
			class="mb-4"
			size="small"
			:text="heading"
			variant="secondary"
			@click="showModal"
		/>
		<div>
			<h2 class="mb-10">{{ heading }}</h2>
			<p>{{ infoText }}</p>
		</div>
		<div class="btns">
			<text-button
				size="small"
				text="Avbryt"
				variant="secondary"
				width="stretch"
				@click="modal = false"
			/>
			<a
				:href="pageLink"
				target="_blank"
				class="text-btn _small _stretch"
				@click="modal = false"
			>
				Till felanmälan
			</a>
		</div>
	</modal>
</template>

<script>
import { convertToCdnUrl } from 'utils';
import bus from 'eventbus';

export default {
	props: {
		heading: {
			type: String,
			default: 'Felanmälan till verkstad',
		},
		infoText: {
			type: String,
			default: 'Genom att felanmäla till verkstaden så har du ett aktivt ärende mellan dig och den auktoriserade verkstaden. Webhallen kan bistå med inblick i ärendet vid frågor men har ingen påverkan i reparationsprocessen mellan dig och tillverkarens verkstad.'/*Sync with placeholder in admin_page.php*/,
		},
		pageLink: {
			type: String,
			default: '',
		},
	},
	data () {
		return {
			modal: false,
		};
	},
	methods: {
		showModal() {
			return this.modal = true;
		}
	},
};
</script>
